<template>
  <!-- <PreloaderPage /> -->
  <div class="market-page">

    <BannerPages
      class="banner-market"
      :title="'market.titlebanner'"
      :descriptions="[
        $t('market.descriptbanner'),
      ]"
      img="/images/market/banner-market.png"
      mainImageWidthDesk="640"
      mainImageHeightDesk="634"
      alt="Hand holding phone with financial app"
    />

    <LazyOffer />
    <LazyDiscover :style="degrade" />
    <LazyAccountstailored
      :title="$t('market.accuntstailored.title')"
      :description="'market.accuntstailored.descript'"
      :description2="'market.accuntstailored.descript2'"
      name_btn
      name_btn_url="/trading/accounts"
      :textBTn="$t('market.accuntstailored.link')"
      :items="accountTailoredItems"
    />
    <LazyPlataformFav/>
    <div class="discover-benefits">
      <LazyMoreResource
        :titleH2="'forms_and_documents.protectedTitle'"
        :cards="cards"
        class="with-icons"
      />
    </div>
    <LazyInvestment
      :label="'market.ready'"
      :buttonConfigs="[
        {
          type: 'external',
          href: getExternalUrl('/register/1/live-account'),
          class: 'primary-button-medium',
          textKey: 'market.btn-invest'
        }
      ]"
    />
  </div>
</template>

<script setup>
import BannerPages from "~/components/BannerPages.vue";
import LazyOffer from "~/components/market/Offer.vue";
import LazyDiscover from "~/components/market/Discover.vue";
import LazyAccountstailored from "~/components/market/Accountstailored.vue";
import LazyPlataformFav from "~/components/market/PlataformFav.vue";
import LazyMoreResource from "~/components/home/MoreResource.vue";
import LazyInvestment from "~/components/Investment";
// import PreloaderPage from "~/components/PreloaderPage.vue";
import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

const { t } = useI18n();
const { getExternalUrl } = useExternalUrl();

const nuxtImg = useImage();

const title = t("seo.markets.title");
const description = t("seo.markets.description");
const imgSeo = 'https://tradeview.eu/images/seo/11Markets.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/market/Markets-Gradient.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

let cards = ref([
  {
    icon: "currency_exchange",
    title: "forms_and_documents.protectedCardTitle1",
    desc: "forms_and_documents.protectedCardDesc1",
  },
  {
    icon: "account_balance_wallet",
    title: "forms_and_documents.protectedCardTitle2",
    desc: "forms_and_documents.protectedCardDesc2",
  },
  {
    icon: "lock",
    title: "forms_and_documents.protectedCardTitle3",
    desc: "forms_and_documents.protectedCardDesc3",
  },
  {
    icon: "acute",
    title: "forms_and_documents.protectedCardTitle4",
    desc: "forms_and_documents.protectedCardDesc4",
  },
]);

let accountTailoredItems = ref([
  { id: 1, icon: "edit", description: "market.accuntstailored.descriptitem1" },
  { id: 2, icon: "dns", description: "market.accuntstailored.descriptitem2" },
  { id: 3, icon: "acute", description: "market.accuntstailored.descriptitem3" },
  {
    id: 4,
    icon: "attach_money",
    description: "market.accuntstailored.descriptitem4",
  },
  {
    id: 5,
    icon: "emoji_objects",
    description: "market.accuntstailored.descriptitem5",
  },
  {
    id: 6,
    icon: "headset_mic",
    description: "market.accuntstailored.descriptitem6",
  },
]);

// // Lógica para la imagen de Discover
// const config = {
//   'ko': '/images/market/03.Markets-Img2-Kor.png',
//   'zh': '/images/market/03.Markets-Img2-Ch.png',
//   'pt-br': '/images/market/03.Markets-Img2-Br.png',
//   'LATAM': '/images/market/03.Markets-Img-mx.png',
//   'es': '/images/market/03.Markets-Img-mx.png',
//   'default': '/images/market/Markets-Img.png',
// };

// const { $regulationsVar } = useNuxtApp();
// const { locale } = useI18n();

// const getDiscoverImageSrc = computed(() => {
//   const regulation = $regulationsVar.getRegulation(locale.value);
//   return config[locale.value] || config[regulation] || config['default'];
// });
</script>